import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AddresspickerComponent} from './addresspicker.component';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AgmCoreModule} from 'angular2-google-maps/core';
import {GOOGLE_PLACES_API_KEY} from '../../../../infrastructure/google-apis/places.config';
import {AddressMapper} from './address-mapper.service';

/**
 * Created by Arturo Campos on 23/01/17.
 */
@NgModule({
    imports: [
      AgmCoreModule.forRoot({
        apiKey: GOOGLE_PLACES_API_KEY,
        libraries: ['places']
      }),
      CommonModule,
      FormsModule,
      NgbModule],
    declarations: [AddresspickerComponent],
    exports: [AddresspickerComponent],
    providers: [AddressMapper]
})
export class AddresspickerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/addresspicker/addresspicker.module.ts